import { render, staticRenderFns } from "./Courses.vue?vue&type=template&id=145bb936&scoped=true"
import script from "./Courses.vue?vue&type=script&lang=js"
export * from "./Courses.vue?vue&type=script&lang=js"
import style0 from "./Courses.vue?vue&type=style&index=0&id=145bb936&prod&lang=scss&scoped=true"
import style1 from "./Courses.vue?vue&type=style&index=1&id=145bb936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145bb936",
  null
  
)

export default component.exports